import { useState, useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";

const ServiceAutoSuggest = ({ services, selectedServiceId, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredServices, setFilteredServices] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Set selected service name when pre-selected
  useEffect(() => {
    if (selectedServiceId && services) {
      const selected = services.find((s) => s._id === selectedServiceId);
      if (selected) setSearchTerm(selected.name || "");
    }
  }, [selectedServiceId, services]);

  // Filter services on search term
  useEffect(() => {
    if (!services) return;
    const filtered = searchTerm
      ? services.filter((s) =>
          s.name.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : services;
    setFilteredServices(filtered);
  }, [searchTerm, services]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (service) => {
    setSearchTerm(service.name);
    setIsOpen(false);
    onSelect(service);
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
    if (!isOpen) setFilteredServices(services); // show all
  };

  return (
    <div ref={wrapperRef}>
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          placeholder="Search or select service..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
        />
        <button
          type="button"
          className="btn border d-flex align-items-center justify-content-center"
          onClick={toggleDropdown}
          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
        >
          <ChevronDown size={18} />
        </button>
      </div>

      {isOpen && filteredServices?.length > 0 && (
        <ul
          className="list-group position-absolute"
          style={{
            width: "25%",
            minWidth: "200px",
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {filteredServices.map((service) => (
            <li
              key={service._id}
              className="list-group-item list-group-item-action"
              style={{ cursor: "pointer", backgroundColor: "whitesmoke" }}
              onClick={() => handleSelect(service)}
            >
              {service.name}
            </li>
          ))}
        </ul>
      )}

      {isOpen && filteredServices?.length === 0 && (
        <div
          className="list-group position-absolute"
          style={{
            width: "25%",
            minWidth: "200px",
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          <div className="list-group-item">No services found</div>
        </div>
      )}
    </div>
  );
};

export default ServiceAutoSuggest;
